import { render, staticRenderFns } from "./admin-app-bar.component.vue?vue&type=template&id=0b1747f1&scoped=true"
import script from "./admin-app-bar.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-app-bar.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-app-bar.component.vue?vue&type=style&index=0&id=0b1747f1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1747f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1747f1')) {
      api.createRecord('0b1747f1', component.options)
    } else {
      api.reload('0b1747f1', component.options)
    }
    module.hot.accept("./admin-app-bar.component.vue?vue&type=template&id=0b1747f1&scoped=true", function () {
      api.rerender('0b1747f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/admin-app-bar/admin-app-bar.component.vue"
export default component.exports